<template>
  <el-dialog
    class="rc-dialog"
    title="分类设置"
    :visible.sync="dialogVisible"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-cascader
      class="cascder-adapt"
      v-model="categoryId"
      placeholder="请选择图书分类"
      :options="videoCategoryData"
      :props="{
        label: 'name',
        value: 'id',
        children: 'children',
        checkStrictly: true,
      }"
      clearable
    >
    </el-cascader>
    <!-- <el-popover placement="bottom" width="400" trigger="hover">
      <div class="tree-content">
        <el-tree
          :data="videoCategoryData"
          show-checkbox
          node-key="id"
          :props="defaultProps"
          :check-strictly="true"
          ref="tree"
          @check-change="handleClick"
        />
      </div>
      <div slot="reference" class="sel-button">
        {{ showName || "请选择图书分类" }}
      </div>
    </el-popover> -->
    <span slot="footer" class="dialog-footer">
      <butn
        class="czButn"
        @click="dialogVisible = false"
        size="small"
        title="取 消"
      />
      <butn type="primary" @click="setCategory" size="small" title="确 定" />
    </span>
  </el-dialog>
</template>

<script>
import { resCategoryTree } from "@/api/rescategory";
import { bookCategory } from "@/api/book";
import vue from "@/main";
import butn from "@/components/button/index";

export default {
  components: { butn },
  data() {
    return {
      dialogVisible: false,
      categoryId: "",
      categoryData: "",
      bookIds: [],
      videoCategoryData: [],
      showName: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  created() {
  },
  methods: {
    show(ids) {
      this.bookIds = ids;
      this.resCategoryTree();
    },
    resCategoryTree() {
      resCategoryTree({ categoryType: 1, display: 1 }).then((res) => {
        if (!res || res.code != 0) return;
        this.videoCategoryData = this.dealSourceData(res.data);
        this.dialogVisible = true;
      });
    },
    dealSourceData(arr) {
      if (!Array.isArray(arr)) return;

      return arr.map((x, i) => {
        let child = {};
        if (x.children) {
          child = { children: this.dealSourceData(x.children) };
        }
        return {
          ...x,
          disabled: x.children && x.children.length > 0,
          ...child,
        };
      });
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
        this.categoryId = data.id;
        this.showName = data.name;
      }
    },
    setCategory() {
      bookCategory({
        uuids: this.bookIds,
        categoryId: this.categoryId.pop(),
      }).then((res) => {
        if (!res || res.code !== 0) return;
        this.$message({
          message: "分类设置成功",
          type: "success",
        });
        this.$emit("initTable");
        this.dialogVisible = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.tree-content {
  max-height: 400px;
  overflow: auto;
}
.sel-button {
  cursor: pointer;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #edf2f9;
  border-radius: 2px;
  border: 1px solid #d7dbe0;
}
.cascder-adapt {
  width: 100%;
}
</style>
